{
  "version": "0.0.0",
  "id": "at.softline.lagerhaus.agrarunion.softline.web",
  "name": "LH Agrarunion Softline"
}
